import { useEffect, useState, useCallback } from 'react';

function useIntersectionObserver(options = { threshold: 0.1, triggerOnce: true }) {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const [node, setNode] = useState(null);

    const threshold = options.threshold;
    const triggerOnce = options.triggerOnce;

    const elementCallbackRef = useCallback(
        (newNode) => {
            setNode(newNode);
        },
        []
    );

    useEffect(() => {
        if (!node || (triggerOnce && isIntersecting)) {
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                const currentIntersectionState = entry.isIntersecting;
                if (currentIntersectionState !== isIntersecting) {
                    setIsIntersecting(currentIntersectionState);
                }
                if (triggerOnce && currentIntersectionState) {
                    observer.disconnect();
                }
            },
            { threshold: threshold }
        );

        observer.observe(node);

        return () => {
            observer.disconnect();
        };

    }, [node, threshold, triggerOnce, isIntersecting]);

    return [elementCallbackRef, isIntersecting];
}

export default useIntersectionObserver;